import OverlayTips from "../OverlayTips";
import APTipsUtils from "../ApTipsUtils";

function MySchedulePageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

MySchedulePageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {

    $tipNotApproved: $(),
    $tipApproved: $(),
    $tipLeaveStatus: $(),

    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        // Requests tab
        this.add(function() {
            // if request tab can be disabled then we can check $('#2.disabled').length == 1 and return empty jquery object $()
            return $('#1.selected').find('.tabContainer');
        }, {
            messageKey: "my_schedule.tips.tab.request",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: 105,
            offsetY: -5
        });

        // BalancesViewer
        this.add(function() {
            var $elem = $('#balancesViewerPlaceholder').find('.balancesViewer');
            var isPto = $elem.hasClass("showPTO");
            var isSick = $elem.hasClass("showSick");
            if (!isPto && !isSick) //don't show the tip
            {
                $elem = $();
                $elem.config = {};
            }
            else
            {
                var messageKey = isPto && isSick ?
                                 "my_schedule.tips.balances_viewer" :
                                 (isPto ? "my_schedule.tips.pto_balance_viewer" : "my_schedule.tips.sick_balance_viewer");
                $elem.config = {
                    messageKey: messageKey,
                    direction: OverlayTips.DIRECTION_TOP_LEFT,
                    offsetX: -6,
                    offsetY: -7
                };
            }
            return $elem;
        });

        // Schedule Tab content

        // click to date
        function clickToDateTipPosition()
        {
            var dayCells = $('#myScheduleTableContainer').find('.firstRow .dayCell');

            var checkCell = function($cell)
            {
                return $cell.hasClass('noLeave') && !$cell.hasClass('nonWorking') && !$cell.hasClass('pastDay');
            };

            var increaseIteration = function(from, to)
            {
                for (var i = from; i <= to; i++)
                {
                    var $cell = $(dayCells[i]);
                    if (checkCell($cell))
                    {
                        return $cell;
                    }
                }
            };

            var decreaseIteration = function(from, to)
            {
                for (var i = to; i >= from; i--)
                {
                    var $cell = $(dayCells[i]);
                    if (checkCell($cell))
                    {
                        return $cell;
                    }
                }
            };

            var result = decreaseIteration(0, dayCells.length - 16);
            if (!_.isUndefined(result)) return result;

            result = increaseIteration(dayCells.length - 15, dayCells.length - 1);
            if (!_.isUndefined(result)) return result;

            return $();
        }

        this.add(clickToDateTipPosition, {
            messageKey: "my_schedule.tips.schedule.new_leave",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -5,
            offsetY: 3
        });

        this.add(_.bind(this._leaveWaitingApprovalTip, this));
        this.add(_.bind(this._leaveApprovedTip, this));
        this.add(_.bind(this._leaveStatusTip, this));

        // Requests tab content

        this.add(function() { return $('#leaveRequestsTable').find('.leaveTypeCell .sortingLink') }, {
            messageKey: "my_schedule.tips.request.sort.leave_type",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -35,
            offsetY: 10
        });

        this.add(function() { return $('#leaveRequestsTable').find('.periodCell .sortingLink') }, {
            messageKey: "my_schedule.tips.request.sort.period",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -5,
            offsetY: 3
        });

        this.add(function() { return $('#leaveRequestsTable').find('.statusCell .sortingLink') }, {
            messageKey: "my_schedule.tips.request.sort.status",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -5,
            offsetY: 3
        });

        this.add(function() { return $('#leaveRequestsTable').find('.balanceTypeFilterBlock table') }, {
            messageKey: "my_schedule.tips.request.filter.balances",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -160,
            offsetY: 25
        });
    },

    refreshDynamicTips: function(animated)
    {
        if(this.enabled)
        {
            // if we on Schedule tab
            if ($('#1.selected').length == 1)
                APTipsUtils.setLeaveChartTableTips(this, $('#colleaguesTable'));
        }

        PageOverlayTipsManager.prototype.refreshDynamicTips.call(this, animated);
    },

    _leaveWaitingApprovalTip: function()
    {
        this.$tipNotApproved.config =
                _.defaults(this.$tipNotApproved.config || {}, {
                    messageKey: "my_schedule.tips.schedule.waiting_approval",
                    noFirstTimeAnimation: true,
                    offsetX: -5,
                    offsetY: 10
                });

        return this.$tipNotApproved;
    },

    _leaveApprovedTip: function()
    {
        this.$tipApproved.config =
                _.defaults(this.$tipApproved.config || {}, {
                    messageKey: "my_schedule.tips.schedule.approved",
                    noFirstTimeAnimation: true,
                    offsetX: -5,
                    offsetY: 10
                });

        return this.$tipApproved;
    },

    _leaveStatusTip: function()
    {
        this.$tipLeaveStatus.config =
                _.defaults(this.$tipLeaveStatus.config || {}, {
                    messageKey: "my_schedule.tips.schedule.leave_status",
                    anchor: OverlayTips.DIRECTION_TOP_RIGHT,
                    noFirstTimeAnimation: true,
                    offsetX: 0,
                    offsetY: 30
                });

        return this.$tipLeaveStatus;
    }
});

export default MySchedulePageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/managers/MySchedulePageOverlayTipsManager.js